import { AppEvents } from "./../../app-events";
import { Container } from "aurelia-dependency-injection";
import { GenericTabModel } from "./../models/tabs/generic-tab";
import { GenericTabView } from "./tabs/generic-tab";
import {backboneViewProperties} from "../../decorators/backbone-properties";
import { ContainerHelper } from "../../shared/helpers/container-helper";

const dom = {
    SECTION_BUTTONS: ".section-button",
    FULLTEXT_SECTION_BUTTONS: ".full-text-button",
    DOCUMENT_SECTIONS: ".document-section",

};

@backboneViewProperties({
    childView: GenericTabView
})
export class PanelTabsView extends Marionette.CollectionView<GenericTabModel, any> {

    protected appEvents: Backbone.Events;
    constructor(private options?: any) {
        super(options);
        this.appEvents = ContainerHelper.Events;
    }

    public buildChildView(child: GenericTabModel, className, childViewOptions) {
        const view = new child.ViewType({model: child});
        return view;
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/desktop/views/panel-tabs.ts